var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-examuser-selector" }, [
    _c("div", { staticClass: "yxtbiz-examuser-selector__left" }, [
      _c(
        "div",
        { staticClass: "clearfix font-size-14" },
        [
          _vm.groupSelect
            ? _c("yxtbiz-group-org-select", {
                staticClass: "mr12 pull-left",
                attrs: {
                  placeholder: _vm.$t("pc_biz_ote_lbl_plsselectorg"),
                  multiple: false,
                },
                on: { change: _vm.changeOrg },
              })
            : _vm._e(),
          _vm.projectId || _vm.taskId
            ? _c(
                "yxt-input",
                {
                  staticClass: "yxtbiz-examuser-selector__keywords",
                  attrs: {
                    size: "small",
                    placeholder: _vm.$t(
                      "pc_biz_udp_tip_searchAccount" /* 请输入姓名/账号搜索 */
                    ),
                    searchable: "",
                  },
                  on: { search: _vm.userNameSearch },
                  model: {
                    value: _vm.name,
                    callback: function ($$v) {
                      _vm.name = $$v
                    },
                    expression: "name",
                  },
                },
                [
                  _c(
                    "yxt-select",
                    {
                      staticClass: "width104",
                      attrs: { slot: "prepend" },
                      slot: "prepend",
                      model: {
                        value: _vm.keywordType,
                        callback: function ($$v) {
                          _vm.keywordType = $$v
                        },
                        expression: "keywordType",
                      },
                    },
                    [
                      _c("yxt-option", {
                        attrs: {
                          label: _vm.$t("pc_biz_core_lbl_accnum" /* 账号 */),
                          value: "0",
                        },
                      }),
                      _c("yxt-option", {
                        attrs: {
                          label: _vm.$t("pc_biz_core_lbl_name" /* 姓名 */),
                          value: "1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("yxt-input", {
                staticClass: "pull-left",
                staticStyle: { width: "240px" },
                attrs: {
                  placeholder: _vm.$t("biz_ote_enter_account"),
                  searchable: "",
                  maxlength: "50",
                },
                on: { search: _vm.userNameSearch },
                model: {
                  value: _vm.userSearch.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.userSearch, "name", $$v)
                  },
                  expression: "userSearch.name",
                },
              }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-examuser-selector__main mt16" },
        [
          _c(
            "yxt-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: _vm.refTable,
              staticClass: "yxtbiz-examuser-selector__table",
              attrs: { data: _vm.userTempList, height: _vm.tableHeight },
              on: { "select-all": _vm.selectAll, select: _vm.select },
            },
            [
              _c("yxt-table-column", {
                attrs: {
                  type: "selection",
                  "show-overflow-tooltip": false,
                  width: "38",
                  align: "right",
                  "clear-padding": "left-right",
                },
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_ote_lbl_cnname"),
                  "show-overflow-tooltip": false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "yxt-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              "popper-class": "yxtbiz-participants-max-tip",
                              "open-filter": true,
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("yxtbiz-user-name", {
                                  attrs: { name: scope.row.fullName },
                                }),
                                _vm._v("\n                ("),
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.userName)),
                                ]),
                                _vm._v(")\n              "),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "ellipsis" },
                              [
                                _c("yxtbiz-user-name", {
                                  attrs: { name: scope.row.fullName },
                                }),
                                _vm._v("\n                ("),
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.userName)),
                                ]),
                                _vm._v(")\n              "),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_ote_lbl_userNo"),
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.userNo || "--") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_ote_lbl_position"),
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.row.positionName || "--") +
                            "\n          "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt16 pr clearfix" },
        [
          _c("yxt-pagination", {
            staticClass: "pull-right",
            attrs: {
              "page-size": _vm.userSearch.limit,
              total: _vm.count,
              "current-page": _vm.page,
              layout: "total, prev, pager, next",
              "page-count": _vm.totalPage,
            },
            on: {
              "size-change": _vm.sizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "yxtbiz-examuser-selector__right" },
      [
        _c(
          "yxt-scrollbar",
          { attrs: { "fit-height": true } },
          _vm._l(_vm.selected, function (item) {
            return _c(
              "yxt-tag",
              {
                key: item.userId,
                staticClass: "mr5 mb5 yxtbiz-examuser-selector__tag",
                attrs: { size: "small", type: "info", closable: "" },
                on: {
                  close: function ($event) {
                    return _vm.deleteItem(item)
                  },
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "flex" },
                  [
                    _c("yxt-svg", {
                      staticClass: "mr5 v-mid",
                      attrs: {
                        width: "14px",
                        height: "24px",
                        "icon-class": "person-center",
                      },
                    }),
                    _c(
                      "span",
                      { staticClass: "user-selector-tag" },
                      [
                        _c(
                          "yxt-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              "popper-class": "yxtbiz-participants-max-tip",
                              "open-filter": true,
                            },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("yxtbiz-user-name", {
                                  attrs: { name: item.fullName },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "ellipsis" },
                              [
                                _c("yxtbiz-user-name", {
                                  attrs: { name: item.fullName },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          1
        ),
        _c(
          "yxt-button",
          {
            staticClass: "user-clear font-size-12 color-gray-9 hover-primary-6",
            attrs: {
              type: "text",
              disabled: Object.values(this.selected).length === 0,
            },
            on: { click: _vm.clear },
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("pc_biz_ote_btn_clearall")) + "\n    "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }